// extracted by mini-css-extract-plugin
export default {"container":"Landing_container__TIHPx","title-div":"Landing_title-div__5vUvz"};